import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Skeleton } from "@/components/ui/Skeleton";
import { EditAprendizDatosPersonalesForm } from "@/components/forms/aprendices/EditAprendizDatosPersonalesForm";
import { useAprendizById } from "@/hooks/aprendices/useAprendices";

type ProgramaAprendizEditDialogProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  idAprendiz: number | null;
  queryKey: ReadonlyArray<unknown>;
};

export function ProgramaAprendizEditDialog({
  open,
  onOpenChange,
  idAprendiz,
  queryKey,
}: ProgramaAprendizEditDialogProps) {
  const { data: aprendiz, isLoading, isError } = useAprendizById(
    idAprendiz ?? undefined,
    open && !!idAprendiz,
  );

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Editar aprendiz</DialogTitle>
          <DialogDescription>
            Actualiza el nombre, apellidos y correo del aprendiz.
          </DialogDescription>
        </DialogHeader>
        {isLoading && (
          <div className="space-y-3 py-2">
            <Skeleton className="h-10 w-full" />
            <Skeleton className="h-10 w-full" />
            <Skeleton className="h-10 w-full" />
            <Skeleton className="h-10 w-full" />
          </div>
        )}
        {isError && (
          <p className="text-sm text-destructive">
            No se pudo cargar el aprendiz. Intenta de nuevo.
          </p>
        )}
        {!isLoading && !isError && aprendiz && (
          <EditAprendizDatosPersonalesForm
            aprendiz={aprendiz}
            queryKey={queryKey}
            close={() => onOpenChange(false)}
          />
        )}
      </DialogContent>
    </Dialog>
  );
}
